module.exports = new __parcel__URL__("hud_battle_royale_view_button.d2764f1f.png").toString();